"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineTableFieldRow = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
const table_field_context_1 = require("../table-field/table-field-context");
const form_context_1 = require("../../composite/form/form-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const inline_table_field_styles_1 = require("./inline-table-field-styles");
const inline_table_context_1 = require("./inline-table-context");
const table_field_drag_handle_1 = require("../table-field/table-field-drag-handle");
const table_field_cells_1 = require("../table-field/table-field-cells");
exports.InlineTableFieldRow = react_1.memo(react_1.forwardRef(function InlineTableFieldRow({ index, value }, ref) {
    const classes = inline_table_field_styles_1.useStyles();
    const { showRemoveDialog, filteredColumns, disabled, useDnDOrdering, visibleActionsColumn, actionColumnWidth, } = react_1.useContext(table_field_context_1.TableFieldContext);
    const { withRemove } = react_1.useContext(inline_table_context_1.InlineTableFieldContext);
    const { editing } = react_1.useContext(form_context_1.FormContext);
    const handleDeleteClick = event_callback_hook_1.useEventCallback(() => {
        showRemoveDialog(index);
    });
    const showDragButton = !disabled && useDnDOrdering;
    const showRemoveButton = withRemove && editing && !disabled;
    return (react_1.default.createElement("div", { className: classes.row, ref: ref },
        visibleActionsColumn && (react_1.default.createElement("div", { className: classes.tableRowActions, style: { width: actionColumnWidth } },
            showDragButton && react_1.default.createElement(table_field_drag_handle_1.DragHandle, { className: classes.rowDraggable }),
            showRemoveButton && react_1.default.createElement(Delete_1.default, { onClick: handleDeleteClick }))),
        filteredColumns.map((column, i) => {
            const { CellComponent = table_field_cells_1.TableFieldCells.TextCell } = column;
            return (react_1.default.createElement("div", { key: i, className: classes.cellWrapper, style: {
                    width: column.width,
                } },
                react_1.default.createElement(CellComponent, { index: index, value: lodash_1.get(value, column.datakey, ''), rowValue: value, column: column })));
        })));
}));
//# sourceMappingURL=inline-table-field-row.js.map